import fleetadviseStyle from "../assets/css/fleetadvise.scss";
import fleetcorStyle from "../assets/css/fleetcor.scss";
import { FLEETCOR } from "../constants/affiliations";
import { extractFirstSubDomain } from "../utils/urlUtils";

const styles = {
  fleetcor: fleetcorStyle,
  fleetadvise: fleetadviseStyle,
};
export function getSubdomain(host) {
  if (!host) {
    host = window.location.hostname;
  }

  let subDomain = extractFirstSubDomain(host);

  if (!Object.prototype.hasOwnProperty.call(styles, subDomain)) {
    subDomain = FLEETCOR;
  }
  return subDomain;
}

export default function StylesheetInjector() {
  let subdomain = getSubdomain();

  let styleSheet = `${process.env.PUBLIC_URL}/css/semantic.min.css`;

  loadStylesheet(styleSheet, () =>
    loadStylesheet(`${process.env.PUBLIC_URL}/css/${subdomain}.css`, () => {
      // document.querySelector("#splash").style.display = "none";
      // document.querySelector("#root").style.display = "block";
    })
  );
}

let loadStylesheet = (url, callback) => {
  let sheet = document.createElement("link");
  sheet.rel = "stylesheet";
  sheet.href = url;
  sheet.type = "text/css";
  sheet.onload = () => callback();
  document.head.appendChild(sheet);
};

export function getStyles() {
  let subdomain = getSubdomain();
  return styles[subdomain];
}
